const toLowerCaseFirstChar = (str: string): string => {
  if (!str) return '';

  const firstChar = str[0].toLowerCase();

  return `${firstChar}${str.substring(1)}`;
};

export default toLowerCaseFirstChar;
